(function () {
  'use strict';

  const root = document.querySelector('.tm-hiw');
  if (!root) return;

  const screen = root.querySelector('.mp-iphone-screen');
  const chips = root.querySelectorAll('.mp-chip');
  const feats = root.querySelectorAll('.mp-feat');
  const live = root.querySelector('.mp-hiw-live');

  const pinImg = root.querySelector('[data-pin-icon]');
  const cardImg = root.querySelector('[data-card-icon]');
  const itemName = root.querySelector('[data-item-name]');
  const locEl = root.querySelector('[data-loc]');
  const distEl = root.querySelector('[data-distance]');
  const bannerText = root.querySelector('[data-banner-text]');
  const siriQ = root.querySelector('[data-siri-q]');
  const siriA = root.querySelector('[data-siri-a]');
  const ringLabel = root.querySelector('[data-ring-label]');

  const DURATIONS = { ring: 3200, siri: 4200, location: 2600, leftbehind: 3400 };
  const FEAT_LABEL = {
    ring: 'Playing locating chirp',
    siri: 'Asking Siri',
    location: 'Updating live location',
    leftbehind: 'Showing left-behind alert'
  };

  let timer = null;
  let currentDemo = null;

  function clearDemo() {
    clearTimeout(timer);
    timer = null;
    currentDemo = null;
    screen.setAttribute('data-demo', '');
    ringLabel.textContent = 'Play Sound';
    feats.forEach((f) => f.setAttribute('aria-pressed', 'false'));
    if (live) live.textContent = '';
  }

  function playDemo(id, btn) {
    clearDemo();
    requestAnimationFrame(() => {
      currentDemo = id;
      screen.setAttribute('data-demo', id);
      if (id === 'ring') ringLabel.textContent = 'Playing…';
      btn.setAttribute('aria-pressed', 'true');
      if (live) live.textContent = (FEAT_LABEL[id] || '') + ' on ' + itemName.textContent + '.';
      timer = setTimeout(clearDemo, DURATIONS[id] || 3000);
    });
  }

  function setScenario(chip) {
    chips.forEach((c) => {
      c.classList.remove('active');
      c.setAttribute('aria-selected', 'false');
    });
    chip.classList.add('active');
    chip.setAttribute('aria-selected', 'true');

    const name = chip.dataset.itemName || '';
    const loc = chip.dataset.loc || '';
    const dist = chip.dataset.distance || '';
    const locShort = chip.dataset.locShort || loc.split('·')[0].trim();
    const iconSrc = chip.dataset.iconSrc || '';

    itemName.textContent = name;
    locEl.textContent = loc;
    distEl.textContent = dist;
    bannerText.textContent = name + ' was last seen at ' + locShort + '.';
    siriQ.textContent = '“' + (chip.dataset.siriQ || '') + '”';
    siriA.textContent = chip.dataset.siriA || '';

    if (iconSrc) {
      pinImg.style.display = '';
      pinImg.src = iconSrc;
      cardImg.style.display = '';
      cardImg.src = iconSrc;
    }

    clearDemo();
  }

  chips.forEach((c) => c.addEventListener('click', () => setScenario(c)));
  feats.forEach((f) => f.addEventListener('click', () => {
    const id = f.dataset.demo;
    if (currentDemo === id) {
      clearDemo();
      requestAnimationFrame(() => playDemo(id, f));
    } else {
      playDemo(id, f);
    }
  }));

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') clearDemo();
  });
})();
